// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsProcessingList_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M16 8V9.99486L8 9.99485V8H16ZM16 11.9897V13.9846H8V11.9897H16ZM17.9998 10.8212 19.4141 9.41058 20.8283 10.8212 23.6567 8.00007 25.0709 9.41065 20.8283 13.6424 17.9998 10.8212ZM16 18V19.9949H8V18H16ZM16 24V22H8V24H16ZM21.2805 18.185C21.1545 17.9383 20.8455 17.9383 20.7195 18.185L18.0457 23.4171C17.9176 23.6679 18.0741 23.9846 18.3262 23.9846H23.6738C23.9259 23.9846 24.0824 23.6679 23.9543 23.4171L21.2805 18.185Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M4 28.0146V3H28L28 28.0146L4 28.0146ZM26 6L6.00006 6L6.00006 26.0198L26 26.0198V6Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsProcessingList is a generated icon component.
 */
let IconRmsProcessingList = IconRmsProcessingList_1 = class IconRmsProcessingList extends IconBaseElement {
    render() {
        return html `${IconRmsProcessingList_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsProcessingList.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconRmsProcessingList = IconRmsProcessingList_1 = __decorate([
    customElement('zui-icon-rms-processing-list')
], IconRmsProcessingList);
export { IconRmsProcessingList };
